// Polska odmiana liczebnikowa: [liczba pojedyncza, liczba mnoga "kilka", liczba mnoga "wiele"]
// np. pluralize(2, ['ogłoszenie', 'ogłoszenia', 'ogłoszeń']) -> 'ogłoszenia'
// Uwzględnia wyjątek 12-14 (i ich setki/tysiące itd.), gdzie mimo końcówki 2-4
// obowiązuje forma "wiele" (np. 112 ogłoszeń, nie 112 ogłoszenia).
const pluralize = (count, forms) => {
    const n = Math.abs(parseInt(count, 10)) || 0
    if (n === 1) return forms[0]

    const mod10 = n % 10
    const mod100 = n % 100
    const isFew = mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)

    return isFew ? forms[1] : forms[2]
}

export default pluralize
